import React, {useState, useEffect, useRef} from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {PURPLE} from "../constants/general-constants";
import {GREY_FONT} from "../constants/general-constants";
import {CSSTransition} from 'react-transition-group';
import './floorrowpercentageslider.css';
import {COLOR_GRAY_BANNER_BACKGROUND} from "../constants/general-constants";
import {functions} from "../constants/common-functions";
import FloorRowIcon from "../components/FloorRowIcon";
import {colorFunctions} from "../constants/colors";

export default function FloorRowSpaceTypePercentage({displayType, spaceTypeId, floorId, floorName, name, area, width, color, isFirst, isLast}){
	
	const [posLeft, setPosLeft] = useState("0px");
	const [posTop, setPosTop] = useState("0px");
	const [displayPopUp, setDisplayPopUp] = useState("none");
	const [thisBorderTopLeftRadius, setThisBorderTopLeftRadius] = useState("0");
	const [thisBorderTopRightRadius, setThisBorderTopRightRadius] = useState("0");
	const [thisBorderBottomLeftRadius, setThisBorderBottomLeftRadius] = useState("0");
	const [thisBorderBottomRightRadius, setThisBorderBottomRightRadius] = useState("0");
	
	
	const thisRef = useRef(null);
	
	useEffect(() => {
		setPosLeft(thisRef.current.getBoundingClientRect().left - 150);
		
		
		if(isFirst === true){
			setThisBorderTopLeftRadius("5px");
			setThisBorderBottomLeftRadius("5px");
		}
		
		if(isLast === true){
			setThisBorderTopRightRadius("5px");
			setThisBorderBottomRightRadius("5px");
		}
		
	}, [floorId, spaceTypeId, width]);
	
	
	
	const thisContainer = {
		display:"flex",
		width:width,
		height:"10px",
		cursor:"pointer",
		backgroundColor:color,
		borderBottomLeftRadius:thisBorderBottomLeftRadius,
		borderTopLeftRadius:thisBorderTopLeftRadius,
		borderBottomRightRadius:thisBorderBottomRightRadius,
		borderTopRightRadius:thisBorderTopRightRadius
	};
	
	const handleMouseOver = () => {
		setPosTop(thisRef.current.getBoundingClientRect().top - 20 + thisRef.current.scrollTop);
		setDisplayPopUp("flex");
	};
	
	const handleMouseLeave = () => {
		setDisplayPopUp("none");
	};
	
	const popUp = {
		display:displayPopUp,
		position:"fixed",
		left:posLeft,
		top:posTop,
		height:"80px",
		width:"400px",
		justifyContent:"space-between",
		borderRadius:"20px",
		alignItems:"center",
		backgroundColor:color
	};
	
	const popUpLabel = {
		display:"flex",
		paddingLeft:"10px",
		color:"white",
		fontSize:"14px"
	};
	
	return (
		<div style={thisContainer} onMouseOver={handleMouseOver} ref={thisRef}  onMouseLeave={handleMouseLeave}>
			<div style={popUp}  onMouseLeave={handleMouseLeave}>
				<div style={popUpLabel}>
					{name}: {area} SQM
				</div>
			</div>
		</div>
	);
}